import { startOfDay, endOfDay, startOfMonth, startOfWeek, subDays, subMonths, subYears } from 'date-fns';

// Range for the account's configured budget period (used as the app-wide default).
export function budgetPeriodRange(period) {
  const now = new Date();
  if (period === 'daily') return { from: startOfDay(now), to: endOfDay(now) };
  if (period === 'weekly') return { from: startOfWeek(now, { weekStartsOn: 1 }), to: endOfDay(now) };
  return { from: startOfMonth(now), to: endOfDay(now) }; // monthly (default)
}

// Stable identity for a range (undefined = no filter), to compare which range
// some data was fetched for against the one currently selected.
export function dateRangeKey(range) {
  return `${range?.from?.getTime?.() ?? ''}|${range?.to?.getTime?.() ?? ''}`;
}

// Quick-filter presets shown in the date picker. The budget-period chip is only
// added for daily/weekly since "Este mes" already covers monthly.
export function presetRanges(budgetPeriod) {
  const now = new Date();
  const list = [];
  if (budgetPeriod === 'daily') list.push({ id: 'period', label: 'Hoy', range: () => budgetPeriodRange('daily') });
  if (budgetPeriod === 'weekly') list.push({ id: 'period', label: 'Esta semana', range: () => budgetPeriodRange('weekly') });
  list.push(
    { id: '7d', label: '7 días', range: () => ({ from: startOfDay(subDays(now, 6)), to: endOfDay(now) }) },
    { id: 'month', label: 'Este mes', range: () => ({ from: startOfMonth(now), to: endOfDay(now) }) },
    { id: '3m', label: '3 meses', range: () => ({ from: startOfDay(subMonths(now, 3)), to: endOfDay(now) }) },
    { id: 'year', label: '1 año', range: () => ({ from: startOfDay(subYears(now, 1)), to: endOfDay(now) }) },
  );
  return list;
}

// True when a preset's range matches the active selection (day-granularity).
export function rangeMatches(range, dateRange) {
  if (!dateRange?.from || !dateRange?.to) return false;
  return startOfDay(range.from).getTime() === startOfDay(dateRange.from).getTime()
    && startOfDay(range.to).getTime() === startOfDay(dateRange.to).getTime();
}
